import { gql } from "@apollo/client";

export const M_LOGIN = gql`
  mutation LoginUser($data: LoginUserInput) {
    loginUser(data: $data) {
      token
    }
  }
`;
